import Vue from 'vue'
import { validEmail } from '@/utils/validate'

function deferred(callback) {
  window.OneSignalDeferred = window.OneSignalDeferred || []
  return new Promise((resolve, reject) => {
    window.OneSignalDeferred.push(async OneSignal => {
      try {
        resolve(await callback(OneSignal))
      } catch (error) {
        reject(error)
      }
    })
  })
}

export function initialize(appId) {
  if (!appId) {
    Vue.$log.warn('OneSignal initialization skipped: missing app ID')
    return Promise.resolve()
  }

  return deferred(async OneSignal => {
    await OneSignal.init({ appId })

    Vue.$log.info('OneSignal initialized', {
      appId,
      permission: OneSignal.Notifications.permission,
      subscriptionId: OneSignal.User.PushSubscription.id,
      optedIn: OneSignal.User.PushSubscription.optedIn
    })

    OneSignal.User.PushSubscription.addEventListener('change', event => {
      Vue.$log.info('OneSignal push subscription changed', event.current)
    })

    OneSignal.Notifications.addEventListener('foregroundWillDisplay', event => {
      Vue.$log.info('OneSignal foreground notification received', event.notification)
      event.preventDefault()
      setTimeout(() => event.notification.display(), 0)
    })
  })
}

export function identifyUser(user) {
  return deferred(async OneSignal => {
    await OneSignal.login(String(user.id))
    if (validEmail(user.email)) {
      await OneSignal.User.addEmail(user.email.toLowerCase())
    }
  })
}

export function logoutUser(email) {
  return deferred(async OneSignal => {
    if (validEmail(email)) {
      await OneSignal.User.removeEmail(email.toLowerCase())
    }
    await OneSignal.logout()
  })
}
